import {
  sizeGuideClick, howToMeasure, styliticsJumpLink, share,
} from './constants';

const getConfig = (configName) => {
  const triggerConfig = {
    [sizeGuideClick]: {
      analytics: 'analytics.pdp_size_guide_click',
      data_text: 'size guide',
      data_action: 'open',
    },
    [howToMeasure]: {
      analytics: 'pdp_size_guide_how_to_measure_click',
      data_text: 'size guide - how to measure',
      data_action: 'open',
    },
    [styliticsJumpLink]: {
      analytics: 'pdp_stylitics_complete_this_look_click',
      data_text: 'stylitics-complete-this-look',
      data_action: 'click',
    },
    [share]: {
      analytics: 'pdp_share_click',
      data_text: 'pdp share',
      data_action: 'share',
    },
  };

  if (triggerConfig[configName]) {
    const defaultConfig = {
      analytics: triggerConfig[configName].analytics,
      data: {
        tealium_event: 'click',
        data_text: triggerConfig[configName].data_text,
        data_action: triggerConfig[configName].data_action,
      },
    };
    return defaultConfig;
  }
  return null;
};

const handleProductAnalytics = (configName) => {
  const config = getConfig(configName);

  if (config && window.digitalData) {
    window.digitalData.trigger(config.analytics, config.data);
  }
};

export default {
  handleProductAnalytics,
};
